import React, { useState, useEffect } from 'react'
// import { useHistory } from 'react-router-dom'
import axios from '../../Axios'
import { Urls } from '../../Urls'
import classes from '../DhandhaNow/DhandaNowFunc.module.css'
import { toast } from 'react-toastify'
import { Constants, Activity, currentRequestTimeStamp } from '../../Constants'
import { useAppContext } from '../../Context/AppContext'

function updateUserPolicy(txn_id, policy_type) {
    var data = {
        // "service_name": 'dhandanow',
        "update_policy": {
            "lane_count": Constants.dhandanow[policy_type]['lane_count'],
            "access_type": Constants.dhandanow[policy_type]['access_type']
        },
        "transaction": {
            "txn_id": txn_id,
            "timestamp": (Date(24 * 3600 * 1000))
        }
    }


    axios.post(Urls.DhandhaNow.user_details, data)
        .then(res => {
            window.location.reload()
        })
        .catch(error => {
            toast.error("Error While Processing your Payment ")
            console.log(error)
        })
}
const ModalUpgrade = ({ groupPolicy1, show = false, allowedSearches }) => {
    // const history = useHistory();
    const [groupPolicy, setgroupPolicy] = useState([])
    // const [loading, setloading] = useState(false)
    // const [show1, setshow1] = useState(false)
    const { transporterInfo } = useAppContext();
    const [userEmail, setUserEmail] = useState('')
    useEffect(() => {
        const email = transporterInfo?.contact_information?.length > 0 && transporterInfo?.contact_information?.find((t) => t?.name === transporterInfo?.transporter_name)?.email
        setUserEmail(email)
    }, [transporterInfo])

    useEffect(() => {
        setgroupPolicy(groupPolicy1)
    }, [groupPolicy1])

    const getAllowedLanes = (policyType = 'standard') => {
        let groupPolicyLength = groupPolicy.length
        for (let i = 0; i < groupPolicyLength; i++) {
            if (groupPolicy[i]['type'] === policyType) {
                return groupPolicy[i]['dhandhanow']['allowed_lanes']
            }
        }
    }
    const getAmount = (policyType = 'standard', amountType = 'final_amount', isPayment = true) => {
        let groupPolicyLength = groupPolicy.length
        for (let i = 0; i < groupPolicyLength; i++) {
            if (groupPolicy[i]['type'] === policyType) {
                return `${groupPolicy[i][amountType]}`.toString()
            }
        }
    }

    // const LaneIntelligence = () => {
    //     history.push({ pathname: '/dhandanow' })
    //     // document.getElementById('upgarde-modal').style.display= 'none';
    // }

    const UpgradeModal = () => {
        return (
            <div className={classes['upgrade-modal']} >
                <h3 className="text-center s-hi"><span>Hello {transporterInfo?.transporter_name}!</span></h3>
                <hr />
                <center>
                    <span className={classes['s-you']} style={{ fontSize: '16px', fontWeight: '100', marginLeft: '2%' }}>Upgrade to get <span style={{ fontWeight: 'bold' }}>feedback</span> on your <span style={{ fontWeight: 'bold' }}>rates</span> and <span style={{ fontWeight: 'bold' }}>LoRRI profile</span>, win more business! </span> <br />
                    <span style={{ fontSize: '16px', fontWeight: '100', marginLeft: '19px', fontStyle: 'italic' }}>Limited time offer!<br /></span>
                    {/* <span style={{ fontSize: '16px', fontWeight: '100', marginLeft: '19px' }}>In addition to <b style={{fontWeight: 'bold'}}>Rate feedback </b> (30 minutes) and <b style={{fontWeight: 'bold'}}> profile feedback</b> (30 minutes), you will be able to search for business on upto 5 lanes</span><br/>
                    <span style={{ fontSize: '16px', fontWeight: '100', marginLeft: '19px' }}>LoRRI 30 day subscription for INR 2500/- only. Limited time offer </span> */}
                </center>

                <div className={`row ${classes['s-ca']} ${classes['s-carow']}`}>
                    {/* <div className="col-sm-6"> */}
                    <div className="pyro" >
                        <div className="before"></div>
                        <div className="after"></div>
                    </div>
                    {/* <div className={`card ${classes['dhandhanow']} ${classes['s-u-dhandhanow']}`}> */}
                    {/* <h6 className="card-text text-center"><b>Free</b></h6> */}
                    {/* <h6 className={`card-text ${classes['s-standard']}`}><b> {getAllowedLanes('standard')} lane searches</b></h6>*/}
                    {/* <span className={`card-text ${classes['s-size']}`}>₹ {getAmount("standard", "display_amount", false)}<span className={classes['gst-text']}> + Taxes (18% GST) </span> </span>  */}
                    {/* <h6 style={{fontSize: '14px', padding: '2%'}}>Get <span style={{fontWeight: 'bold'}}>Rate and LoRRI profile feedback</span> for one tender submitted on LoRRI  </h6> */}
                    {/* <hr/> */}
                    {/* <ul className="b" style={{marginTop: '20%'}}>
                                <li style={{fontWeight: 'normal', fontSize: '14px'}}>Sharable Profile option <span style={{fontWeight: 'bold'}}></span></li>
                                <li style={{fontWeight: 'normal', fontSize: '14px'}}>Access to LoRRI Enquiries</li>
                                <li style={{fontWeight: 'normal', fontSize: '14px'}}>24*7 Customer Service</li>
                                <li style={{fontWeight: 'normal', fontSize: '14px'}}>Get LoRRI Profile feeback <span style={{fontWeight: 'normal'}}>for one tender submitted on LoRRI</span></li>
                                <li style={{fontWeight: 'normal', fontSize: '14px'}}>Search for <span style={{fontWeight: 'bold'}}>business <span style={{fontWeight: 'normal'}}>from</span> leading client</span></li>
                            </ul> */}
                    {/* <button
                                style={{marginTop: '4%'}}
                                type="button"
                                className={`btn btn-sm ${classes['s-wi']}`}
                                onClick={openStandardCheckout}>
                                Subscribe Now
                            </button> */}
                    {/* <span style={{fontSize: '11px', fontWeight: 'normal', marginLeft: '19%', marginTop: '10px', fontStyle: 'italic'}}>valid for 60 days from payment*</span> */}

                    {/* </div> */}
                    {/* </div> */}
                    <div className={`col-sm-12 ${classes['s-pre-div']}`} >
                        <div className={`card ${classes['dhandhanow']} ${classes['s-u-dhandhanow']}`}>
                            <h6 className="card-text text-center"><b>Premium</b></h6>
                            {/* <h6 className={`card-text ${classes['s-standard']}`}><b> {getAllowedLanes('premium')} lane searches</b></h6> */}
                            <span className={`card-text ${classes['s-size']}`}>₹ {getAmount('premium', 'display_amount', false)} <span className={classes['gst-text']}> + Taxes (18% GST) </span> </span>
                            {/* <h6 style={{fontSize: '14px', padding: '2%'}}>Get <span style={{fontWeight: 'bold'}}>Rate and LoRRI profile feedback</span>, search for <span style={{fontWeight: 'bold'}}>business</span> from <span style={{fontWeight: 'bold'}}>leading clients</span> </h6> */}
                            <hr />
                            <ul className="b">
                                <li style={{ fontWeight: 'normal', fontSize: '14px' }}><span style={{ fontWeight: 'bold' }}>Warm Introduction  to Client </span></li>
                                <li style={{ fontWeight: 'normal', fontSize: '14px' }}>Get  <span style={{ fontWeight: 'bold' }}>Rate feeback</span></li>
                                <li style={{ fontWeight: 'normal', fontSize: '14px' }}>Get  <span style={{ fontWeight: 'bold' }}>LoRRI Profile feeback</span></li>
                                <li style={{ fontWeight: 'normal', fontSize: '14px' }}>Search for <span style={{ fontWeight: 'bold' }}>business <span style={{ fontWeight: 'normal' }}>from</span> leading clients</span></li>
                                {/* <li style={{fontWeight: 'normal', fontSize: '14px'}}> + All free features & much more </li> */}
                            </ul>
                            {/* <span style={{fontSize: '11px', fontWeight: 'normal', marginLeft: '18%', marginTop: '10px', fontStyle: 'italic'}}>valid for 60 days from payment*</span> */}

                        </div>
                    </div>
                </div>

                <div className={`col-12 ${classes['s-des']}`}>
                    <span className={`${classes['s-dess']}`} style={{ fontWeight: '100', marginLeft: '10%' }}>
                        For more information contact us at <b style={{ fontWeight: 'bold' }}> +91-8655923451/ +91-8861502288</b> or mail us at <u style={{ color: '#393186' }}>lorri@logisticsnow.in</u>
                    </span>
                    <div>
                        {/* <span style={{ fontSize: '16px', fontWeight: '100', marginLeft: '19px', fontStyle: 'italic' }}>Limited time offer<br/></span>                 */}
                    </div>
                </div>
            </div>
        )
    }

    const UpgradeModal1 = () => {
        return (
            <div className={classes['upgrade-modal']} >
                <br />
                <h3 className="text-center s-hi"><span style={{ fontSize: '25px' }}>Upgrade Now</span></h3>
                <hr /><br />
                <center>
                    <span className={classes['s-you']} style={{ fontSize: '35px', fontWeight: 'bold' }}>
                        Hello {transporterInfo?.transporter_name}!
                    </span>
                </center><br />
                <span style={{ fontSize: '20px', fontWeight: '100', marginLeft: '7%' }}>
                    To find out how you can get guaranteed business, please drop us an email on
                </span><br />
                <span style={{ fontSize: '20px', fontWeight: '100', marginLeft: '20%' }}>
                    lorri@logisticsnow.in or call us on  +91-9867773519.
                </span>
            </div>
        )
    }

    const closeUpgradeModal = () => {
        document.getElementById('subscribe_pop_up').style.display = 'none'
        show = false
    }

    const closeUpgradeModal1 = () => {
        document.getElementById('subscribe_pop_up1').style.display = 'none'
    }

    const closeUpgradeModal3 = () => {
        document.getElementById('creditsmodal').style.display = 'none'
    }


    const UpgradeModal2 = () => {
        return (
            <div className={classes['upgrade-modal']} >
                <h3 className="text-center s-hi"><span>Hi {transporterInfo?.transporter_name}</span></h3>
                <span style={{ fontSize: 'large', marginLeft: '2%' }}>Your Credits have Expired!  In order to continue the experience kindly choose one of the offers.</span>
                {/* <span className={classes['s-cred']}><span className={` ${classes['s-pcred']}`}>Your Credits have Expired!</span> In order to continue the experience kindly choose one of the offers.</span> */}
                {/* <span className={` ${classes['s-cont']}`}><b></b></span> */}
                <div className={`row ${classes['s-ca']} ${classes['s-carow']}`}>
                    <div className="col-sm-6">
                        <div className="pyro" >
                            <div className="before"></div>
                            <div className="after"></div>
                        </div>
                        <div className={`card ${classes['dhandhanow']} ${classes['s-u-dhandhanow']}`} style={{ height: '190px' }}>
                            {/* <div className={classes['bookmark']} style={{ height: "10px", width: "50px" }}>
                                <span className={classes['bookmarktext']}>{getDiscountPercentage('standard')}% off</span>
                            </div> */}
                            <h6 className="card-text text-center"><b>Standard</b></h6>
                            <h6 className={`card-text ${classes['s-standard']}`}><b>{getAllowedLanes('standard')} lane searches</b></h6>
                            <span className={`card-text ${classes['s-size']}`}>₹ {getAmount("standard", "display_amount", false)}<span className={classes['gst-text']}> + Taxes (18% GST) </span> </span>
                            {/* <span className="card-text text-center" style={{ fontSize: "x-large", textDecoration: "line-through" }}>₹ {getAmount("standard", "policy_amount", false)}</span> */}

                            {/* <button
                                type="button"
                                className={`btn btn-sm ${classes['s-wi']}`}
                                onClick={openStandardCheckout}>
                                Upgrade Now
                            </button> */}
                        </div>
                    </div>
                    <div className="col-sm-6" style={{ marginLeft: '-6%' }}>
                        <div className={`card ${classes['dhandhanow']} ${classes['s-u-dhandhanow']}`} style={{ height: '190px' }}>
                            {/* <div className={classes['bookmark']} style={{ height: "10px", width: "50px" }}>
                                <span className={classes['bookmarktext']}>{getDiscountPercentage('premium')}% off</span>
                            </div> */}
                            <h6 className="card-text text-center"><b>Premium</b></h6>
                            <h6 className={`card-text ${classes['s-standard']}`}><b>{getAllowedLanes('premium')} lane searches</b></h6>
                            <span className={`card-text ${classes['s-size']}`}>₹ {getAmount('premium', 'display_amount', false)} <span className={classes['gst-text']}> + Taxes (18% GST) </span> </span>
                            {/* <span className="card-text text-center" style={{ fontSize: "x-large", textDecoration: "line-through" }}>₹ {getAmount('premium', 'policy_amount', false)} </span> */}
                        </div>
                    </div>
                </div>
                <div className={`col-12 ${classes['s-des']}`} style={{ marginTop: '-13%' }}>
                    <span className={`${classes['s-dess']}`}>
                        Charges mentioned above are for a quarterly subscription, expiring 90 days from the date of payment. Any unused credit can be used upon renewal of subscription.
                    </span>
                </div>
            </div>
        )
    }

    return (
        <>
            {show ?
                allowedSearches === 0 ?
                    <div style={{ display: 'block', zIndex: '50000', marginLeft: '5%', height: '70%', boxShadow: 'inset 0 0 10px', borderRadius: '15px' }} className={classes['upgrademodal']} id="creditsmodal">
                        <i onClick={closeUpgradeModal3} className={` fa fa-window-close ${classes['s-upgrade-div']}`}></i>
                        <UpgradeModal2 />
                    </div>
                    : <div style={{ display: 'block', zIndex: '50000', marginLeft: '15%', height: '75%', boxShadow: 'inset 0 0 10px', borderRadius: '15px' }} className={classes['upgrademodal']} id="upgrademodal">
                        <i onClick={closeUpgradeModal} className={` fa fa-window-close ${classes['s-upgrade-div']}`}></i>
                        <UpgradeModal />
                    </div>
                :
                transporterInfo.showLoader && !transporterInfo.policy ? <div style={{ display: 'block', zIndex: '50000', height: '50%', boxShadow: 'inset 0 0 10px', borderRadius: '15px' }} className={classes['upgrademodal']} id="subscribe_pop_up1">
                    <i onClick={closeUpgradeModal1} className={` fa fa-window-close ${classes['s-upgrade-div']}`}></i>
                    <UpgradeModal1 />
                </div> : null
            }

        </>
    )
}

export default ModalUpgrade
